import 'reflect-metadata';
import { html } from 'lit';
window.qbo4 = window.qbo4 || {};
window.qbo4.configuration = window.qbo4.configuration || {};
window.qbo4.configuration.html = html;
export { LitElement, css, html } from "lit";
export { customElement, property, state } from "lit/decorators.js";
export { services } from '@quandis/qbo4.ui';
export * from './qbo-document.js';
export * from './qbo-document-viewer.js';
export * from './qbo-file.js';
export * from './qbo-file-viewer.js';
export * from './qbo-file-explorer.js';
export * from './IDocumentInfo.js';
export * from './styles.js';
